import React, { Component } from "react";
import { connect } from "react-redux";

//import { setMenuState } from "../actions/siteActions";
import { isMobile } from "react-device-detect";
import { useSwipeable, Swipeable } from "react-swipeable";

import Topbar from "./components/Topbar";
import Catalog from "./components/Catalog";
import FullScreenElements from "./components/FullScreenElements";
import Login from "./components/Login";

import { setCurrentCategory } from "./actions/siteActions";

class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      swipeDirection: 0,
    };
  }

  setMenuState = () => {
    const { site } = this.props;
    this.props.setMenuState(!site.menu.open);
  };
  userSwipedRight = () => {
    this.setState({
      swipeDirection: 1,
    });
    this.returnNormal(1);
  };
  userSwipedLeft = () => {
    this.setState({
      swipeDirection: -1,
    });
    this.returnNormal(-1);
  };

  returnNormal = (direction) => {
    /* setTimeout(
      function () {
        this.setState({
          swipeDirection: 0
        })
        this.changePage(direction);
      }.bind(this),
      1000 //animation time
    );
 */
    this.setState({
      swipeDirection: 0,
    });
    this.changePage(direction);
  };

  changePage = (direction) => {
    const { site } = this.props;
    Object.keys(site.categories).map((cat, i) => {
      if (site.categories[cat].id === site.current.category.id) {
     
        if (site.categories.length - 1 <= i) {
          if (direction === 1) {
            this.props.setCurrentCategory(site.categories[0]);
          } else {
            this.props.setCurrentCategory(site.categories[i + direction]);

            // move left while more pages than 1
  
          }
        } else if (i <= 0) {
          if (direction === 1) {
            this.props.setCurrentCategory(site.categories[i + direction]);
          } else {
            this.props.setCurrentCategory(
              site.categories[site.categories.length - 1]
            );
          }
        } else {
          this.props.setCurrentCategory(site.categories[i + direction]);

          if (direction !== 1) {
            // move left while more pages than 1
            /* console.log(
              "site.current.category.count 1 ",
              site.categories[i + direction].count,
              site.current.category.count
            );*/
          }
        }
      }
    });
  };

  render() {
    const { site } = this.props;
    //localStorage.getItem("token")
    if (site.user && site.user.loggedIn) {
      return (
        <React.Fragment>
          <Topbar />

          {isMobile ? (
            <Swipeable
              onSwipedRight={this.userSwipedRight}
              onSwipedLeft={this.userSwipedLeft}
              preventDefaultTouchmoveEvent={true}
            >
              <Catalog swipeDirection={this.state.swipeDirection} />
            </Swipeable>
          ) : (
            <Catalog />
          )}

          <FullScreenElements />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Login />
          <FullScreenElements />
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setCurrentCategory })(View);
